var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "premium-information" }, [
    _c("div", { staticClass: "premium-information-title" }, [
      _vm._v(_vm._s(_vm.$t(`common.premiumFeature.${_vm.routeName}.title`))),
    ]),
    _c("div", { staticClass: "premium-information-description" }, [
      _vm._v(_vm._s(_vm.$t(`common.premiumFeature.${_vm.routeName}.content`))),
    ]),
    _c("div", { staticClass: "premium-information-invite" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.$t("common.premiumFeature.invitePrefix", {
              feature: _vm.$t(`common.premiumFeature.${_vm.routeName}.feature`),
            })
          )
        ),
      ]),
      _c("br"),
      _c("span", { staticClass: "premium-color" }, [
        _vm._v(_vm._s(_vm.$t("common.premiumFeature.premiumMember"))),
      ]),
      _c("span", [
        _vm._v(_vm._s(_vm.$t("common.premiumFeature.inviteSuffix"))),
      ]),
    ]),
    _c("div", { staticClass: "premium-information-description" }, [
      _vm._v(_vm._s(_vm.$t("common.premiumFeature.description"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }